// The identity of THIS bundle (docs/deployment.md "Build identity"): the commit it was built
// from (web/Dockerfile bakes --build-arg GIT_SHA as VITE_GIT_SHA) and package.json's version
// (vite.config.ts `define`). Local dev has neither → 'unknown' / 'dev', and every comparison that
// depends on them stays quiet.

const sha = (import.meta.env.VITE_GIT_SHA ?? '').trim();

export const BUILD = {
  sha: sha && !sha.startsWith('$') ? sha : 'unknown',
  version: typeof __APP_VERSION__ === 'string' && __APP_VERSION__ ? __APP_VERSION__ : 'dev',
} as const;

export const REPO_URL = (import.meta.env.VITE_REPO_URL ?? 'https://github.com/greenlighttec/novapsa').replace(/\/+$/, '');

/** Link to a commit on the repository host, or null for an unknown sha. */
export function commitUrl(sha: string | null | undefined): string | null {
  return sha && sha !== 'unknown' ? `${REPO_URL}/commit/${sha}` : null;
}

/** Short form for display. */
export function shortSha(sha: string | null | undefined): string {
  return sha && sha !== 'unknown' ? sha.slice(0, 7) : 'unknown';
}
